import React from 'react';
import cn from 'classnames';

import { weekDaysOptions } from 'Shared/constants/constants';

import './DayPicker.scss';

type Props = {
  byNumber?: boolean;
  choosenDays: Array<string>;
  onDayClick: Function;
  variant?: 'blue' | 'red';
};

function DayPicker({ byNumber = false, choosenDays, onDayClick, variant = 'blue' }: Props) {
  return (
    <div className="day-picker d-flex cursor-pointer">
      {weekDaysOptions.map(({ label, value, dayNumber }) => (
        <div
          key={value}
          className={cn('day-picker-item text-center rounded-circle mr-2', `day-picker-color-${variant}`, {
            'day-picker-item--active': choosenDays.includes(byNumber ? dayNumber : value),
          })}
          onClick={() => onDayClick(byNumber ? dayNumber : value)}
        >
          {label}
        </div>
      ))}
    </div>
  );
}

export default DayPicker;
